var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBullets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_79987",
    "data-name": "Group 79987",
    transform: "translate(-25.507 -118.507)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1055",
    "data-name": "Ellipse 1055",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(25.507 118.507)",
    fill: "#3f4fa3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1056",
    "data-name": "Ellipse 1056",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(29.507 122.507)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullets);
export default __webpack_public_path__ + "static/media/bullets.4a523345eccf1640fbb5528d97ed6b6b.svg";
export { ForwardRef as ReactComponent };